export const LEAVE_FEEDBACK_URL = (userId: string) => `/member/${userId}/feedback/new`
